import React from 'react';
import * as S from './missing-id-badge.styles';

export interface IMissingIdBadgeProps {
    className?: string;
    children?: React.ReactNode;
}

export const MissingIdBadge: React.FunctionComponent<IMissingIdBadgeProps> = (
    props: IMissingIdBadgeProps,
): React.ReactElement => {
    const { className, children } = props;
    return (
        <S.MissingId className={className}>
            <S.Message>{children}</S.Message>
        </S.MissingId>
    );
};
